import { icons, type IconName } from "./iconData.ts";

interface Props {
  name: IconName;
  /** Taille en pixels (côté le plus long). */
  size?: number;
  class?: string;
}

/** Icônes de l'app MySmartBook (Material Symbols et dessins maison), décoratives par défaut. */
export function Icon({ name, size = 24, class: className }: Props) {
  const { vb, paths } = icons[name];
  const [, , w = 24, h = 24] = vb.split(" ").map(Number);
  const ratio = w / h;
  const width = ratio >= 1 ? size : size * ratio;
  const height = ratio >= 1 ? size / ratio : size;
  return (
    <svg class={className} viewBox={vb} width={width} height={height} aria-hidden="true" focusable="false">
      {paths.map((p, i) => (
        <path
          key={i}
          d={p.d}
          fill={p.fill}
          stroke={p.stroke}
          stroke-width={p.sw}
          stroke-linecap={p.round ? "round" : undefined}
          stroke-linejoin={p.round ? "round" : undefined}
          fill-rule="nonzero"
        />
      ))}
    </svg>
  );
}

export type { IconName };
